export const START_APPLICATION = 'START_APPLICATION';

export interface StartApplicationAction { type: typeof START_APPLICATION }